import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { SUMMARY_CONTAINER_STYLE } from "common/styles/styles";
import {
  SUMMARY_DISPLAY_LABEL_VALUE_COMPONENT,
  SUMMARY_DISPLAY_DATE_VALUE_COMPONENT,
  SUMMARY_DISPLAY_TIME_VALUE_COMPONENT,
  SUMMARY_DISPLAY_LABEL_VALUE_COMPONENT_FULL_LENGTH
} from "common/utils/SummaryUtil";

class SummaryFlightDelayDetailComponent extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const detail = this.props.detail;

    return (
      <React.Fragment>
        <Grid container style={SUMMARY_CONTAINER_STYLE} spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h6">Original Departure Details</Typography>
          </Grid>
          {SUMMARY_DISPLAY_LABEL_VALUE_COMPONENT(
            "Common Carrier No..",
            detail.originalFlightNumber
          )}

          {SUMMARY_DISPLAY_LABEL_VALUE_COMPONENT(
            "Place of Departure",
            detail.originalPlaceOfDeparture
          )}

          {SUMMARY_DISPLAY_DATE_VALUE_COMPONENT(
            "Original Date of Travel",
            detail.originalDate
          )}

          {SUMMARY_DISPLAY_TIME_VALUE_COMPONENT(
            "Original Time of Travel",
            detail.originalTime
          )}

          {SUMMARY_DISPLAY_LABEL_VALUE_COMPONENT(
            "Transport Provider",
            detail.originalTransportProvider
          )}

          {SUMMARY_DISPLAY_LABEL_VALUE_COMPONENT(
            "Type of Common Carrier",
            detail.originalTypeOfCarrier
          )}

          {SUMMARY_DISPLAY_LABEL_VALUE_COMPONENT_FULL_LENGTH(
            "Reason(s) By Service Provider For the Cause of Delay",
            detail.reason
          )}

          <Grid item xs={12}>
            <Typography variant="h6">Rescheduled Departure Details</Typography>
          </Grid>

          {SUMMARY_DISPLAY_LABEL_VALUE_COMPONENT(
            "Common Carrier No..",
            detail.rescheduledFlightNumber
          )}

          {SUMMARY_DISPLAY_LABEL_VALUE_COMPONENT(
            "Place of Departure",
            detail.rescheduledPlaceOfDeparture
          )}

          {SUMMARY_DISPLAY_DATE_VALUE_COMPONENT(
            "Actual Date of Travel",
            detail.rescheduledDate
          )}

          {SUMMARY_DISPLAY_TIME_VALUE_COMPONENT(
            "Actual Time of Travel",
            detail.rescheduledTime
          )}

          {SUMMARY_DISPLAY_LABEL_VALUE_COMPONENT(
            "Transport Provider",
            detail.rescheduledTransportProvider
          )}

          {SUMMARY_DISPLAY_LABEL_VALUE_COMPONENT(
            "Type of Common Carrier",
            detail.rescheduledTypeOfCarrier
          )}
        </Grid>
      </React.Fragment>
    );
  }
}

export default SummaryFlightDelayDetailComponent;
